export const PERMS = {
    READ: 'units.read',
    UPDATE: 'units.update',
    DELETE: 'units.delete',
    CREATE: 'units.create',
    EXPORT: 'units.export',
}
